import React, { useState } from 'react'
import { provinces } from '../data/provinces'
import MapPath from './MapPath'
import { TooltipProvider } from './Tooltip'
import { RwandaMapProps } from './types'

const RwandaMap: React.FC<RwandaMapProps> = ({
  selectedColor = '#3B82F6',
  defaultColor = '#E5E7EB',
  strokeColor = '#4B5563',
  height = 600,
  scale = 0.95,
  position = { x: 50, y: 50 },
  onProvinceSelect,
  provinceNameColor = '#FFFFFF',
}) => {
  const [hoveredProvince, setHoveredProvince] = useState<string | null>(null)

  const handleProvinceMouseEnter = (provinceName: string) => {
    setHoveredProvince(provinceName)
    onProvinceSelect?.(provinceName)
  }

  const handleProvinceMouseLeave = () => {
    setHoveredProvince(null)
    onProvinceSelect?.(null)
  }

  return (
    <TooltipProvider>
      <div className="relative flex items-center justify-center w-full" style={{ height }}>
        <svg
          viewBox="0 0 1000 1000"
          className="w-full h-full max-w-[800px]"
          role="img"
          aria-label="Interactive map of Rwanda province"
          style={{
            maxHeight: '100%',
            aspectRatio: '1',
          }}
        >
          <g stroke={strokeColor} strokeWidth="1" fill="none" fillRule="evenodd" transform={`scale(${scale}) translate(${position.x}, ${position.y})`}>
            {provinces.map((province) => (
              <MapPath
                key={province.id}
                province={province}
                isHovered={hoveredProvince === province.name}
                selectedColor={selectedColor}
                defaultColor={defaultColor}
                strokeColor={strokeColor}
                onMouseEnter={handleProvinceMouseEnter}
                onMouseLeave={handleProvinceMouseLeave}
                provinceNameColor={provinceNameColor}
              />
            ))}
          </g>
        </svg>
      </div>
    </TooltipProvider>
  )
}

export default RwandaMap
